import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

const CHANNELS = ['Email', 'Envoy Twilio', 'Push', 'Slack'];
const STATUSES = ['delivered', 'failed', 'in_progress', 'not_attempted', 'sent'];

export default Factory.extend({
  channel: () => faker.helpers.arrayElement(CHANNELS),
  status: () => faker.helpers.arrayElement(STATUSES),
});
